export const FOLLOWUP_NUDGE_TYPE = {
  NO_FOLLOWUP: 'NO_FOLLOWUP',
  OVERDUE: 'OVERDUE',
  UPCOMING: 'UPCOMING',
} as const;

export type FollowUpNudgeType = typeof FOLLOWUP_NUDGE_TYPE[keyof typeof FOLLOWUP_NUDGE_TYPE];

export interface FollowUpNudgeBottomSheetData {
  type: FollowUpNudgeType;
  followUpId: string;
  followUpDate?: string;
  lastUpdatedAt?: string;
  regimenClass?: string;
}
